// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import voucherReducer from './voucherSlice';

const store = configureStore({
  reducer: {
    vouchers: voucherReducer,
  },
});

export default store;
